var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ArraySchema, Schema, type } from "@colyseus/schema";
// Synced, per-player sparse overrides of the match game-config tables. Only
// keys that differ from the match snapshot are stored on the Player; readers
// merge via `resolveBuilding` / `resolveVigorZone`. When present, an entry is a
// full building / zone object (same shape as the match tables).
/** Build / attack / defend range; 0 = not applicable. */
export class BuildingRangeState extends Schema {
    constructor() {
        super(...arguments);
        this.build = 0;
        this.attack = 0;
        this.defend = 0;
    }
}
__decorate([
    type("uint8")
], BuildingRangeState.prototype, "build", void 0);
__decorate([
    type("uint8")
], BuildingRangeState.prototype, "attack", void 0);
__decorate([
    type("uint8")
], BuildingRangeState.prototype, "defend", void 0);
/** Per-player override of one building's config (mirrors `BuildingConfig`). */
export class BuildingConfigState extends Schema {
    constructor() {
        super(...arguments);
        /** Cost as [minerals, food, vigor, obsidian]. */
        this.cost = new ArraySchema();
        this.range = new BuildingRangeState();
        this.vigorPenalty = false;
        /** Extra of the node's own resource paid when built on a permanent-resource node. */
        this.permanentResourceCost = 0;
        this.blockOpponentBuild = false;
        /** Resources stolen from the victim per building this one destroys in combat. */
        this.stolenResourceCount = 0;
    }
}
__decorate([
    type(["uint16"])
], BuildingConfigState.prototype, "cost", void 0);
__decorate([
    type(BuildingRangeState)
], BuildingConfigState.prototype, "range", void 0);
__decorate([
    type("boolean")
], BuildingConfigState.prototype, "vigorPenalty", void 0);
__decorate([
    type("uint8")
], BuildingConfigState.prototype, "permanentResourceCost", void 0);
__decorate([
    type("boolean")
], BuildingConfigState.prototype, "blockOpponentBuild", void 0);
__decorate([
    type("uint8")
], BuildingConfigState.prototype, "stolenResourceCount", void 0);
/** Per-player override of one vigor zone's data (mirrors `VigorZoneData`). */
export class VigorZoneState extends Schema {
    constructor() {
        super(...arguments);
        this.name = "";
        /** Bonus to permanent yields as [minerals, food, vigor, obsidian]. */
        this.permanentResourceBonus = new ArraySchema();
        /** Bonus to one-time payouts as [minerals, food, vigor, obsidian]. */
        this.oneTimeResourceBonus = new ArraySchema();
        this.vigorPenalty = 0;
        this.barracksAttackUpkeep = 0;
    }
}
__decorate([
    type("string")
], VigorZoneState.prototype, "name", void 0);
__decorate([
    type(["uint8"])
], VigorZoneState.prototype, "permanentResourceBonus", void 0);
__decorate([
    type(["uint8"])
], VigorZoneState.prototype, "oneTimeResourceBonus", void 0);
__decorate([
    type("uint8")
], VigorZoneState.prototype, "vigorPenalty", void 0);
__decorate([
    type("uint8")
], VigorZoneState.prototype, "barracksAttackUpkeep", void 0);
//# sourceMappingURL=PlayerConfigState.js.map